import { ApiQueryConfig } from 'api/types';
import { createApiEndpoint } from 'api/utils';
import { URLS } from 'config';

type SystemType = { Name: string; Id: number };
type GetSystemTypesConfig = ApiQueryConfig<
  SystemType[],
  unknown,
  unknown,
  unknown
>;

export const getSystemTypes = createApiEndpoint<GetSystemTypesConfig>({
  method: 'GET',
  url: `${URLS.app}/api/SystemTypes`,
});
